import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2, MailCheck } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const { refresh } = useAuth();
  const [state, setState] = useState("loading"); // loading | ok | bad

  useEffect(() => {
    if (!token) { setState("bad"); return; }
    (async () => {
      try {
        await api.post("/auth/verify-email", { token });
        setState("ok");
        try { await refresh(); } catch {/* ignore */}
      } catch {
        setState("bad");
      }
    })();
  }, [token, refresh]);

  return (
    <div className="min-h-screen bg-[#FBF7F1] text-[#1A1A1A] flex items-center justify-center px-5 py-10">
      <div className="w-full max-w-md text-center" data-testid="verify-email-page">
        <div className="h-16 w-16 rounded-2xl bg-[#FAF7F0] border border-[#F0EBE3] mx-auto flex items-center justify-center">
          {state === "loading" && <Loader2 className="h-7 w-7 text-[#6B6B6B] animate-spin" />}
          {state === "ok" && <CheckCircle2 className="h-8 w-8" style={{ color: "#34D399" }} />}
          {state === "bad" && <XCircle className="h-8 w-8" style={{ color: "#FF3B30" }} />}
        </div>

        {state === "loading" && (
          <>
            <h1 className="font-display text-2xl mt-5">Stiamo verificando…</h1>
            <p className="text-sm text-[#9A9A9A] mt-2">Un attimo solo.</p>
          </>
        )}

        {state === "ok" && (
          <>
            <h1 className="font-display text-3xl mt-5 leading-tight">
              Email confermata.<br/>
              <span className="orio-grad-text">Sei ufficialmente parte di ORIO.</span>
            </h1>
            <p className="text-sm text-[#6B6B6B] mt-3">
              Da ora ricevi gli alert SOS della tua zona e tutte le notifiche di sicurezza.
            </p>
            <div className="mt-7 flex flex-col gap-2">
              <Link to="/app" data-testid="verify-go-app"
                className="w-full orio-cta-btn px-6 py-4 rounded-full text-black font-semibold inline-flex items-center justify-center gap-2">
                <MailCheck className="h-5 w-5" /> Vai in ORIO
              </Link>
            </div>
          </>
        )}

        {state === "bad" && (
          <>
            <h1 className="font-display text-2xl mt-5">Link non valido o scaduto</h1>
            <p className="text-sm text-[#9A9A9A] mt-2">
              Il link di verifica è scaduto o è già stato usato. Apri ORIO e richiedi un nuovo link dal banner in cima.
            </p>
            <div className="mt-6 flex flex-col gap-2">
              <Link to="/app" data-testid="verify-go-home"
                className="w-full px-5 py-3 rounded-full bg-white text-black font-semibold">
                Vai in ORIO
              </Link>
              <Link to="/login" className="text-xs text-[#9A9A9A] hover:text-[#1A1A1A]">Accedi di nuovo</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
